import { render, staticRenderFns } from "./AskDev.vue?vue&type=template&id=05055053&scoped=true&"
import script from "./AskDev.vue?vue&type=script&lang=js&"
export * from "./AskDev.vue?vue&type=script&lang=js&"
import style0 from "./AskDev.vue?vue&type=style&index=0&id=05055053&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05055053",
  null
  
)

export default component.exports